<template>
  <div
    :class="clientType == 'pc' ? 'pc-aliplayer' : 'aliplayer'"
    v-if="cur_data.chapter_type == 1"
  >
    <div id="player-con"></div>
  </div>
</template>

<script>
import pcCommonMethods from '../views/pcviews/mixins/index.js'
import RateComponent from './RateComponent'
import { mapState } from 'vuex'

export default {
  props: ['clientType'],
  mixins: [pcCommonMethods],
  data() {
    return {
      player: null,
      source: '',
      path: this.$route.path,
    }
  },
  computed: {
    ...mapState({
      videoUrl: state => state.video_url,
      videoFinish: state => state.video_finished,
      showList: state => state.showList,
      cur_data: state => state.cur_data,
      cur_chap_index: state => state.currentChapterIndex,
      cur_part_index: state => state.currentPartIndex,
      videoTime: state => state.videoTime
    })
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.initPlayer(this.videoUrl)
      })
    })
  },
  beforeDestroy() {
    if (this.player) {
      if(!this.videoFinish) this.$store.commit('videoTime', this.player.getCurrentTime())
      this.player.dispose()
      this.player = null
    }
  },
  deactivated() {
    if (this.player) {
      if(!this.videoFinish) this.$store.commit('videoTime', this.player.getCurrentTime())
      this.player.dispose()
      this.player = null
    }
  },
  watch: {
    videoUrl(newS, oldS) {
      // this.player.dispose();
      this.$nextTick(() => {
        // this.initPlayer(newS);
        this.player.seek(0)
        this.$store.commit('videoTime', 0)
        this.$store.commit('videoHeadTime', 0)
        this.player.loadByUrl(newS, 0)
        if (this.player.getStatus() !== 'playing') {
          this.player.play()
        }
      })
    },
    videoFinish(nv) {
      if (nv) {
        // this.player.dispose()
      }
    },
    showList(show_n) {
      if (this.player) {
        if (show_n) {
          this.player.pause()
        } else {
          this.player.play()
        }
      }
    }
  },
  methods: {
    initPlayer(source) {
      // debugger
      let player_obj = {
        id: 'player-con',
        width: '100%',
        height: '100%',
        autoplay: true,
        playsinline: true, // H5是否内置播放
        useH5Prism: true, // 强制H5播放器
        showBarTime: '2500',
        controlBarVisibility: this.clientType === 'pc' ? 'hover' : 'click', // 控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
        language: 'zh-cn',
        source: source,
        isLive: false,
        preload: true,
        'skinLayout': [
          {
            'name': 'controlBar',
            'align': 'blabs',
            'x': 0,
            'y': 0,
            'children': [
              {
                'name': 'progress',
                'align': 'blabs',
                'x': 0,
                'y': 44
              },
              {
                'name': 'playButton',
                'align': 'tl',
                'x': 15,
                'y': 12
              },
              {
                'name': 'timeDisplay',
                'align': 'tl',
                'x': 10,
                'y': 7
              },
              {
                'name': 'fullScreenButton',
                'align': 'tr',
                'x': 10,
                'y': 12
              }
            ]
          }
        ],
        components: [{
          name: 'RateComponent',
          type: RateComponent,
          args: [{
            rate: sessionStorage.playerRate ? sessionStorage.playerRate : '1'
          }]
        }]
      }
      if ($('#player-con').children().length == 0) {
        this.player = new Aliplayer(player_obj)
      } else {
        this.player.dispose()
        this.player = new Aliplayer(player_obj)
      }
      this.player.on('ended', () => {
        this.$store.commit('video_finished', true)
        this.$emit('videoWatch', true)
      })
      this.player.on('ready', () => {
         if(this.videoTime) {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            this.player.loadByUrl(this.videoUrl, this.videoTime)
          } else {
            this.player.seek(this.videoTime)
          }
          this.$nextTick(() => {
            this.$store.commit('videoTime', 0)
          })
        }
        this.$store.commit('video_finished', false)
        /* 存小节学习状态 */
        this.setLessonLocation(this.cur_part_index, this.cur_chap_index)
      })
      this.player.on('play', () => {
        let cur_data = this.cur_data
        cur_data.is_finished = 1
        this.$store.commit('cur_data', cur_data)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aliplayer {
  width: 100%;
  height: 4.2rem;
  &.for-pc {
    height: 470px;
  }
}
.pc-aliplayer {
  height: 99%;
}
</style>
